"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { useState } from "react";

interface Button3DProps {
	href?: string;
}

export const Button3D = ({ href = "/" }: Button3DProps) => {
	const [count, setCount] = useState(0);

	return (
		<div className={cn("flex flex-col items-center gap-4 p-4 rounded-lg ")}>
			<Link href={href}>
				<button className="join-button w-48 h-50" type="button">
					<div className="bg" />
					<svg
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 342 208"
						className="splash w-60 h-auto"
					>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M54.1054 99.7837C54.1054 99.7837 40.0984 90.7874 26.6893 97.6362C13.2802 104.485 1.5 97.6362 1.5 97.6362"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M285.273 99.7841C285.273 99.7841 299.28 90.7879 312.689 97.6367C326.098 104.486 340.105 95.4893 340.105 95.4893"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M281.133 64.9917C281.133 64.9917 287.96 49.8089 302.934 48.2295C317.908 46.6501 319.712 36.5272 319.712 36.5272"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M281.133 138.984C281.133 138.984 287.96 154.167 302.934 155.746C317.908 157.326 319.712 167.449 319.712 167.449"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M230.578 57.4476C230.578 57.4476 225.785 41.5051 236.061 30.4998C246.337 19.4945 244.686 12.9998 244.686 12.9998"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M230.578 150.528C230.578 150.528 225.785 166.471 236.061 177.476C246.337 188.481 244.686 194.976 244.686 194.976"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M170.392 57.0278C170.392 57.0278 173.89 42.1322 169.571 29.54C165.252 16.9478 168.751 2.05227 168.751 2.05227"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M170.392 150.948C170.392 150.948 173.89 165.844 169.571 178.436C165.252 191.028 168.751 205.924 168.751 205.924"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M112.609 57.4476C112.609 57.4476 117.401 41.5051 107.125 30.4998C96.8492 19.4945 98.5 12.9998 98.5 12.9998"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							d="M112.609 150.528C112.609 150.528 117.401 166.471 107.125 177.476C96.8492 188.481 98.5 194.976 98.5 194.976"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M62.2941 64.9917C62.2941 64.9917 55.4671 49.8089 40.4932 48.2295C25.5194 46.6501 23.7159 36.5272 23.7159 36.5272"
						/>
						<path
							strokeLinecap="round"
							strokeWidth={3}
							strokeOpacity="0.3"
							d="M62.2941 145.984C62.2941 145.984 55.4671 161.167 40.4932 162.746C25.5194 164.326 23.7159 174.449 23.7159 174.449"
						/>
					</svg>
					<div className="wrap">
						<svg
							aria-hidden="true"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 221 42"
							height={42}
							width={221}
							className="path"
						>
							<path
								strokeLinecap="round"
								strokeWidth={3}
								d="M182.674 2H203C211.837 2 219 9.16344 219 18V24C219 32.8366 211.837 40 203 40H18C9.16345 40 2 32.8366 2 24V18C2 9.16344 9.16344 2 18 2H47.8855"
							/>
						</svg>
						<div className="outline" />
						<div className="content">
							<span className="char state-1">
								<span
									data-label="J"
									style={{ "--i": 1 } as React.CSSProperties}
								>
									J
								</span>
								<span
									data-label="o"
									style={{ "--i": 2 } as React.CSSProperties}
								>
									o
								</span>
								<span
									data-label="i"
									style={{ "--i": 3 } as React.CSSProperties}
								>
									i
								</span>
								<span
									data-label="n"
									style={{ "--i": 4 } as React.CSSProperties}
								>
									n
								</span>
								<span
									data-label="T"
									style={{ "--i": 5 } as React.CSSProperties}
								>
									T
								</span>
								<span
									data-label="o"
									style={{ "--i": 6 } as React.CSSProperties}
								>
									o
								</span>
								<span
									data-label="d"
									style={{ "--i": 7 } as React.CSSProperties}
								>
									d
								</span>
								<span
									data-label="a"
									style={{ "--i": 8 } as React.CSSProperties}
								>
									a
								</span>
								<span
									data-label="y"
									style={{ "--i": 9 } as React.CSSProperties}
								>
									y
								</span>
							</span>
							<div className="icon">
								<div />
							</div>
							<span className="char state-2">
								<span
									data-label="J"
									style={{ "--i": 1 } as React.CSSProperties}
								>
									J
								</span>
								<span
									data-label="o"
									style={{ "--i": 2 } as React.CSSProperties}
								>
									o
								</span>
								<span
									data-label="i"
									style={{ "--i": 3 } as React.CSSProperties}
								>
									i
								</span>
								<span
									data-label="n"
									style={{ "--i": 4 } as React.CSSProperties}
								>
									n
								</span>
								<span
									data-label="N"
									style={{ "--i": 5 } as React.CSSProperties}
								>
									N
								</span>
								<span
									data-label="o"
									style={{ "--i": 6 } as React.CSSProperties}
								>
									o
								</span>
								<span
									data-label="w"
									style={{ "--i": 7 } as React.CSSProperties}
								>
									w
								</span>
							</span>
						</div>
					</div>
				</button>
			</Link>

			<style jsx>{`
                .join-button {
                    --white: #ffe7ff;
                    --purple-100: #f4b1fd;
                    --purple-200: #d190ff;
                    --purple-300: #c389f2;
                    --purple-400: #8e26e2;
                    --purple-500: #5e2b83;
                    --radius: 18px;
                    border-radius: var(--radius);
                    cursor: pointer;
                    letter-spacing: -1px;
                    background: 0 0;
                    border: 0;
                    outline: none;
                    font-family: Arial;
                    font-size: 23px;
                    position: relative;
                    transform: rotate(353deg)skew(4deg)
                }

                .bg {
                    border-radius: inherit;
                    filter: blur(1px);
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0
                }

                .bg:before,.bg:after {
                    content: "";
                    border-radius: calc(var(--radius)*1.1);
                    background: var(--purple-500);
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0
                }

                .bg:before {
                    filter: blur(5px);
                    transition: all .3s;
                    box-shadow: -7px 6px #734b9b66,-14px 12px #734b9b4d,-21px 18px 4px #734b9b40,-28px 24px 8px #734b9b26,-35px 30px 12px #734b9b1f,-42px 36px 16px #734b9b14,-56px 42px 20px #734b9b0d
                }

                .wrap {
                    border-radius: inherit;
                    background: linear-gradient(to bottom,var(--purple-100)0%,var(--purple-400)100%);
                    height: 100%;
                    padding: 3px;
                    transition: all .3s;
                    position: relative;
                    overflow: hidden;
                    transform: translate(6px,-6px)
                }

                .outline {
                    opacity: 0;
                    border-radius: inherit;
                    outline: none;
                    transition: all .4s;
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    overflow: hidden
                }

                .outline:before {
                    content: "";
                    background: linear-gradient(90deg,#0000,#fff,#0000);
                    width: 120px;
                    height: 300px;
                    margin: auto;
                    animation: 3s linear infinite paused spin;
                    position: absolute;
                    top: 2px;
                    right: 2px;
                    bottom: 2px;
                    left: 2px
                }

                .content {
                    pointer-events: none;
                    z-index: 1;
                    border-radius: calc(var(--radius)*.85);
                    background: linear-gradient(to bottom,var(--purple-300)0%,var(--purple-400)100%);
                    height: 100%;
                    box-shadow: inset -2px 12px 11px -5px var(--purple-200),inset 1px -3px 11px #00000059;
                    justify-content: center;
                    align-items: center;
                    gap: 16px;
                    font-weight: 600;
                    transition: all .3s;
                    display: flex;
                    position: relative
                }

                .content:before {
                    content: "";
                    z-index: 10;
                    opacity: .7;
                    background: linear-gradient(to bottom,transparent,var(--purple-400));
                    filter: brightness(1.3)blur(5px);
                    width: 80%;
                    margin: auto;
                    position: absolute;
                    top: 45%;
                    right: 0;
                    bottom: 35%;
                    left: 0
                }

                .char {
                    justify-content: center;
                    align-items: center;
                    transition: all .3s;
                    display: flex
                }

                .char span {
                    color: #0000;
                    display: block;
                    position: relative
                }

                .char span:nth-child(5) {
                    margin-left: 5px
                }

                .char.state-1 span:nth-child(5) {
                    margin-right: -3px
                }

                .char.state-1 span {
                    animation: charAppear 1.2s ease backwards calc(var(--i)*30ms)
                }

                .char.state-1 span:before,.char span:after {
                    content: attr(data-label);
                    color: var(--white);
                    text-shadow: -1px 1px 2px var(--purple-500);
                    position: absolute;
                    left: 0
                }

                .char span:before {
                    opacity: 0;
                    transform: translateY(-100%)
                }

                .char.state-2 {
                    position: absolute;
                    left: 60px
                }

                .char.state-2 span:after {
                    opacity: 1
                }

                .icon {
                    z-index: 10;
                    animation: .8s cubic-bezier(.7,-.5,.3,1.2) forwards resetArrow
                }

                .icon div,.icon div:before,.icon div:after {
                    background-color: var(--white);
                    border-radius: 1px;
                    height: 3px
                }

                .icon div:before,.icon div:after {
                    content: "";
                    transform-origin: 100%;
                    border-radius: 15px;
                    width: 14px;
                    transition: all .3s;
                    position: absolute;
                    right: 0
                }

                .icon div {
                    width: 24px;
                    box-shadow: -2px 2px 5px var(--purple-400);
                    background: linear-gradient(to bottom,var(--white),var(--purple-100));
                    animation: 1s ease-in-out infinite paused swingArrow;
                    position: relative;
                    transform: scale(.9)
                }

                .icon div:before {
                    box-shadow: 1px -2px 3px -1px var(--purple-400);
                    animation: 1s linear infinite paused rotateArrowLine;
                    top: 1px;
                    transform: rotate(44deg)
                }

                .icon div:after {
                    box-shadow: -2px 2px 3px 0 var(--purple-400);
                    background: linear-gradient(200deg,var(--white),var(--purple-100));
                    animation: 1s linear infinite paused rotateArrowLine2;
                    bottom: 1px;
                    transform: rotate(316deg)
                }

                .path {
                    z-index: 12;
                    stroke-dasharray: 150 480;
                    stroke-dashoffset: 150px;
                    pointer-events: none;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0
                }

                .splash {
                    pointer-events: none;
                    stroke-dasharray: 60 60;
                    stroke-dashoffset: 60px;
                    stroke: var(--purple-300);
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: translate(-17%,-31%)
                }

                .join-button:hover .words {
                    opacity: 1
                }

                .join-button:hover .words span {
                    animation-play-state: running
                }

                .join-button:hover .char.state-1 span:before {
                    animation: charAppear .7s ease calc(var(--i)*30ms)
                }

                .join-button:hover .char.state-1 span:after {
                    opacity: 1;
                    animation: charDisappear .7s ease calc(var(--i)*30ms)
                }

                .join-button:hover .wrap {
                    transform: translate(8px,-8px)
                }

                .join-button:hover .outline {
                    opacity: 1
                }

                .join-button:hover .outline:before,.join-button:hover .icon div:before,.join-button:hover .icon div:after,.join-button:hover .icon div {
                    animation-play-state: running
                }

                .join-button:active .bg:before {
                    filter: blur(5px);
                    opacity: .7;
                    box-shadow: -7px 6px #734b9b66,-14px 12px #734b9b40,-21px 18px 4px #734b9b26
                }

                .join-button:active .content {
                    box-shadow: inset -1px 12px 8px -5px #47008966,inset 0 -3px 8px 0 var(--purple-200)
                }

                .join-button:active .words,.join-button:active .outline {
                    opacity: 0
                }

                .join-button:active .wrap {
                    transform: translate(3px,-3px)
                }

                .join-button:active .splash {
                    animation: .8s cubic-bezier(.3,0,0,1) 50ms forwards splash
                }

                .join-button:focus .path {
                    animation: 1.6s .2s forwards path
                }

                .join-button:focus .icon {
                    animation: 1s cubic-bezier(.7,-.5,.3,1.5) forwards arrow
                }

                .char.state-2 span:after,.join-button:focus .char.state-1 span {
                    animation: charDisappear .5s ease forwards calc(var(--i)*30ms)
                }

                .join-button:focus .char.state-2 span:after {
                    animation: charAppear 1s ease backwards calc(var(--i)*30ms)
                }

                @keyframes spin {
                    to {
                        transform: rotate(360deg)
                    }
                }

                @keyframes charAppear {
                    0% {
                        opacity: 0;
                        filter: blur(20px);
                        transform: translateY(50%)
                    }

                    20% {
                        opacity: 1;
                        transform: translateY(70%)
                    }

                    50% {
                        opacity: 1;
                        filter: blur();
                        transform: translateY(-15%)
                    }

                    to {
                        opacity: 1;
                        transform: translateY(0)
                    }
                }

                @keyframes charDisappear {
                    0% {
                        opacity: 1;
                        transform: translateY(0)
                    }

                    to {
                        opacity: 0;
                        filter: blur(3px);
                        transform: translateY(-70%)
                    }
                }

                @keyframes arrow {
                    0% {
                        opacity: 1
                    }

                    50% {
                        opacity: 0;
                        transform: translate(60px)
                    }

                    51% {
                        opacity: 0;
                        transform: translate(-200px)
                    }

                    to {
                        opacity: 1;
                        transform: translate(-128px)
                    }
                }

                @keyframes swingArrow {
                    50% {
                        transform: translate(5px)scale(.9)
                    }
                }

                @keyframes rotateArrowLine {
                    50% {
                        transform: rotate(30deg)
                    }

                    80% {
                        transform: rotate(55deg)
                    }
                }

                @keyframes rotateArrowLine2 {
                    50% {
                        transform: rotate(330deg)
                    }

                    80% {
                        transform: rotate(300deg)
                    }
                }

                @keyframes resetArrow {
                    0% {
                        transform: translate(-128px)
                    }

                    to {
                        transform: translate(0)
                    }
                }

                @keyframes path {
                    0% {
                        stroke: #fff
                    }

                    to {
                        stroke-dashoffset: -480px;
                        stroke: #f9c6fe
                    }
                }

                @keyframes splash {
                    to {
                        stroke-dasharray: 2 60;
                        stroke-dashoffset: -60px
                    }
                }
            `}</style>
		</div>
	);
};
